import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { normasVals } from './logic/normas-logic';
import { AppTemplate_HEAD } from './prototype/app.template';
import { NormasTemplate, NormasTemplate_HEAD } from './prototype/normas.template';
import { slots } from './dc/runtime';
import { getLang, tr, useLang } from './i18n';
import { LangToggle } from './i18n/toggle';

// What the prototype runtime (prototype/support.js) puts around a page: FULL_PAGE_CSS, the page's <helmet> (title, font
// links, CSS) and the pseudo-class sheet, then React inside <div id="dc-root"><div class="sc-host">.
const FULL_PAGE_CSS = 'html,body{height:100%;margin:0}#dc-root,#dc-root>.sc-host{height:100%}';
function install(head: { title: string; links: { rel: string; href: string }[]; css: string; pseudoCss: string }) {
  const add = (el: HTMLElement) => document.head.appendChild(el);
  const style = (css: string) => { const s = document.createElement('style'); s.textContent = css; add(s); };
  style(FULL_PAGE_CSS);
  document.title = head.title;
  for (const l of head.links) { const e = document.createElement('link'); e.rel = l.rel; e.href = l.href; add(e); }
  style(head.css);
  if (head.pseudoCss) style(head.pseudoCss);
}

const normas = location.pathname === '/normas';
install(normas ? NormasTemplate_HEAD : AppTemplate_HEAD);
document.documentElement.lang = getLang();
// With the language switch in the header, a phone's name and "Log out" keep one line (the name shortens with "…").
// Spanish never wrapped there, so the prototype's screens are unchanged.
if (!normas) { const st = document.createElement('style'); st.textContent = '[data-dc-tpl="82"]{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;min-width:0}[data-dc-tpl="83"]{white-space:nowrap}[data-dc-tpl="81"]{min-width:0}'; document.head.appendChild(st); }

// Normas de participación in the chosen language; the switch after the header's link back to the league.
slots['7'] = normas ? { at: 'end', node: () => <LangToggle /> } : slots['7'];
function Normas() {
  useLang();
  document.title = tr(NormasTemplate_HEAD.title);
  return <>{NormasTemplate(normasVals())}</>;
}
const root = createRoot(document.getElementById('dc-root')!);
const client = new QueryClient({ defaultOptions: { queries: { retry: false, refetchOnWindowFocus: false, staleTime: 30_000 } } });
root.render(
  <div className="sc-host" data-sc-name={normas ? 'Normas de participación' : 'Liga Inversora Zenit'}>
    {normas ? <Normas /> : <QueryClientProvider client={client}><App /></QueryClientProvider>}
  </div>,
);
